import { type RequiredPick } from '../../../@types/build';
import { type AddToCartInput, type ProductOptionFieldsFragment, type ProductSelectionType } from '../__generated__/graphql-client-types';

export enum OptionSelectionType {
	SINGLE,
	MULTIPLE,
	INDEPENDENT
}

export type OptionSelection = {
	id: string;
	name: string;
	type: OptionSelectionType;
	value: any;
	price: number;
	selected: boolean;
	quantity?: number;
	params?: Record<string, any>;
};

export type GroupSelection = {
	id: string;
	valid: boolean;
	selectionType: ProductSelectionType;
	options: OptionSelection[];
};

export type Selection = {
	id: number;
	price: number;
	quantity: number;
	groups: GroupSelection[];
	total: number;
	initialTotal?: number;
	isABundle?: boolean;
};

export type ProductOptionSelection = {
	selection?: Selection;
	update?: (
		option: ProductOptionFieldsFragment,
		optionSelection: OptionSelection,
		group?: RequiredPick<Partial<GroupSelection>, 'id' | 'valid'>
	) => void;
	changeSelection?: (selection?: Selection) => void;
};

export type AddToCartSelection<T> = {
	pricedOptions: T[];
	subItems?: AddToCartInput[];
};

export type UpdateSelectionParams = {
	option: ProductOptionFieldsFragment;
	optionSelection: OptionSelection;
	groupSelection?: RequiredPick<Partial<GroupSelection>, 'id' | 'valid'>;
};
